module.exports = __webpack_public_path__ + "assets/webgl/art_080_L0.jpg.astc.54620d73.ktx";